<script>
  /**
   * FAB Type
   * - This component is used to handle the type of the FAB.
   *
   * @param {Object} fab_item - The FAB item object.
   * @param {String} classNames - The class names of the FAB.
   */
  export let fab_item = {};
  export let classNames = "";

  // Components.
  import Anchor_Link from "./Types/Anchor_Link.svelte";
  import Auth_Logout from "./Types/Auth_Logout.svelte";
  import Link from "./Types/Link.svelte";
  import Modal from "./Types/Modal.svelte";
  import Featured_Product from "./WooCommerce/Featured_Product.svelte";
  import Print from "./Types/Print.svelte";
  import ScrolltoTop from "./Types/ScrolltoTop.svelte";

  // Components.
  const components = {
    // Regular Type.
    anchor_link: Anchor_Link,
    link: Link,
    print: Print,
    scrolltotop: ScrolltoTop,

    // Modal Type.
    auth_logout: Auth_Logout,
    modal: Modal,

    // WooCommerce.
    featured_product: Featured_Product,
  };

  // Define the component.
  let Component = null;
  if (fab_item.modal) {
    // Set it as modal if there is a modal object.
    Component = components.modal;
  } else if (fab_item.type && components[fab_item.type]) {
    // Set it as the type if it exists.
    Component = components[fab_item.type];
  } else {
    // Default to link if nothing else.
    Component = components.link;
  }
</script>

<svelte:component this={Component} {fab_item} {classNames} />
